import React from 'react';
import options from '../../../../helpers/ContentFulOptions';
import { ParsedContentWrapper } from './styles/RichText.styles';
import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
  renderRichText,
} from '@vhub/gatsby-source-contentful/rich-text';

type TextAlignProps =
  | 'start'
  | 'end'
  | 'left'
  | 'right'
  | 'center'
  | 'justify'
  | 'match-parent';

export type RichTextProps = {
  kind?: 'richText';
  id?: string;
  text?: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  color?: string;
  textAlign?: TextAlignProps;
  className?: string;
  __typename?: string;
};

const RichText = (props: RichTextProps) => {
  const { text, color, textAlign, className } = props;

  function convertTextAlignmentToLogical(): TextAlignProps | undefined {
    switch (textAlign) {
      case 'left':
        return 'start';
      case 'right':
        return 'end';
      default:
        return textAlign;
    }
  }

  if (!text) {
    return null;
  }

  return (
    <ParsedContentWrapper
      color={color}
      textAlign={convertTextAlignmentToLogical()}
      className={className}
    >
      <React.Fragment>{renderRichText(text, options)}</React.Fragment>
    </ParsedContentWrapper>
  );
};

export default RichText;
